import { useEffect, useState } from 'react';

import { getCssVarValue } from '@editor/utils/css';
import { themeStyle, useTheme } from '@repo/ui/theming';
import { Appearance } from '@stripe/stripe-js';

const useElementsAppearance = (): Appearance => {
  const { theme } = useTheme();

  const [appearance, setAppearance] = useState<Appearance>({});

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    setAppearance({
      theme: 'stripe',
      rules: {
        '.Tab': {
          color: getCssVarValue(themeStyle.varInkMain)!,
          boxShadow: 'unset',
          borderRadius: themeStyle.radiusMedium,
        },
        '.Tab--selected, .Tab:focus, .Tab:active, .Tab--selected:focus, .Tab--selected:hover, .Tab:hover':
          {
            color: getCssVarValue(themeStyle.varInkMain)!,
            border: `1px solid ${getCssVarValue(themeStyle.varSelectionBlue)}`,
            boxShadow: 'unset',
          },
        '.TabLabel': {
          fontSize: themeStyle.fontSize14,
          fontWeight: themeStyle.fontSemiBold.toString(),
        },
        '.TabIcon--selected, .TabIcon:hover, .TabIcon--selected:hover, .TabIcon--selected:focus, .TabIcon:focus':
          {
            fill: getCssVarValue(themeStyle.varInkMain)!,
          },
        '.Input': {
          padding: '11px 12px',
          border: `1px solid ${getCssVarValue(themeStyle.varInkLight)}`,
          fontSize: themeStyle.fontSize14,
          outline: 'none',
        },
        '.Input--invalid': {
          boxShadow: 'none',
        },
        '.Input:focus': {
          borderColor: getCssVarValue(themeStyle.varInkLight)!,
          boxShadow: getCssVarValue(themeStyle.varShadowSmallFocus)!,
        },
        '.Label, .Error': {
          fontSize: themeStyle.fontSize11,
        },
      },
      variables: {
        fontFamily: 'Inter',
        fontWeightNormal: String(themeStyle.fontRegular),
        fontWeightBold: String(themeStyle.fontBold),
        colorText: getCssVarValue(themeStyle.varInkMain),
        colorTextPlaceholder: getCssVarValue(themeStyle.varInkMedium),
        colorIcon: getCssVarValue(themeStyle.varInkMain),
        colorIconCheckmark: getCssVarValue(themeStyle.varSelectionBlue),
        spacingTab: '12px',
        borderRadius: themeStyle.radiusMedium,
        colorBackground: getCssVarValue(themeStyle.varBackgroundAltSolid),
        colorDanger: getCssVarValue(themeStyle.varAlertRed),
      },
    });
  }, [theme]);

  return appearance;
};

export default useElementsAppearance;
